import React from "react";
import { DocumentType } from "../../models/document-storage.types";

export type DocumentFilter = DocumentType | "all";

interface FilterOption {
  value: DocumentFilter;
  label: string;
}

const FILTER_OPTIONS: FilterOption[] = [
  { value: "all", label: "All" },
  { value: "unit_of_work", label: "Units of work" },
  { value: "lesson_plan", label: "Lesson plans" },
  { value: "worksheet", label: "Worksheets" },
  { value: "slideshow", label: "Slideshows" },
];

interface DocumentTypeFilterProps {
  active: DocumentFilter;
  counts: Record<DocumentFilter, number>;
  onChange: (filter: DocumentFilter) => void;
}

export const DocumentTypeFilter: React.FC<DocumentTypeFilterProps> = ({
  active,
  counts,
  onChange,
}) => {
  return (
    <div
      className="document-type-filter"
      role="tablist"
      aria-label="Filter by type"
    >
      {FILTER_OPTIONS.map((option) => {
        const isActive = option.value === active;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={
              "document-type-filter__chip" +
              (isActive ? " document-type-filter__chip--active" : "")
            }
            onClick={() => onChange(option.value)}
          >
            {option.label}
            <span className="document-type-filter__count">
              {counts[option.value] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
};
